import { ComponentType, memo, ReactNode, useEffect } from 'react';
import { FieldAttributes, useFormikContext } from 'formik';

import FormField from '../form-field/FormField';
import { IBasicInputProps, Icons } from 'types';
import { getPriceForToken } from 'utils';

interface IProps extends FieldAttributes<any> {
  name: string;
  label?: ReactNode;
  placeholder?: string;
  inputComponent?: ComponentType<IBasicInputProps<any> & any>;
  disabled?: boolean;
  required?: boolean;
  fieldlabel?: string;
  icon?: Icons;
  defaultValue?: string | number | boolean;
}

interface MakeBidInterface {
  amountToBuy: string;
  ccToBid: string;
  priceForToken: string;
}

const CalculatedFormField = (props: IProps) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    const formValues = values as MakeBidInterface;

    const amount = parseFloat(formValues.amountToBuy);
    const bid = parseFloat(formValues.ccToBid);

    if (!isNaN(amount) && !isNaN(bid) && amount > 0 && bid > 0) {
      const priceForToken = getPriceForToken(bid, amount);
      setFieldValue('priceForToken', priceForToken);
    } else {
      setFieldValue('priceForToken', '');
    }
  }, [setFieldValue, values]);

  return <FormField {...props} />;
};

export default memo(CalculatedFormField);
